import { css } from "@emotion/react";
import { useState } from "react";

import QuestListBody from "~/components/category/[id]/quest/QuestListBody";
import QuestTabHead from "~/components/category/[id]/quest/QuestTabHead";
import {
  ORDER_TYPE,
  QuestOrder,
  QuestState,
} from "~/components/category/[id]/quest/lib";
import {
  QUEST_DURATION_STATUSES,
  QuestDurationStatus,
} from "~/domains/quest/lib";
import CollaborationQuestList from "~/extensions/colabo-quest/CollaborationQuestListBody";
import { extractCollaboratedQuests } from "~/extensions/colabo-quest/lib";
import Banner from "~/extensions/radio-form/components/Banner";
import { mediaQueryIsDesktop } from "~/lib/client/design";
import { CategoryDetailQuery } from "~/lib/graphql/client";
import { useCategoryDetailContext } from "~/pages/category/[id]";

const QuestTab = () => {
  const { props } = useCategoryDetailContext();
  const questGenreTags = props.category.quests
    .flatMap((quest) => quest.questGenreTags)
    .reduce(
      (acc, tag) => {
        if (acc.find((t) => t.id === tag.id)) return acc;
        return [...acc, tag];
      },
      [] as CategoryDetailQuery["category"]["quests"][number]["questGenreTags"]
    );

  const [selectedQuestStatus, setSelectedQuestStatus] = useState<QuestState[]>(
    []
  );
  const [selectedSort, setSelectedSort] = useState<QuestOrder>(ORDER_TYPE[0]);
  const [selectedDurationStatus, setSelectedDurationStatus] =
    useState<QuestDurationStatus>(QUEST_DURATION_STATUSES[0]);
  const [selectedQuestGenreTags, setSelectedQuestGenreTags] = useState<
    CategoryDetailQuery["category"]["quests"][number]["questGenreTags"]
  >([]);

  const collaboratedQuests = extractCollaboratedQuests({
    quests: props.category.quests,
    categoryId: props.category.id,
  });

  return (
    <>
      <QuestTabHead
        selectedQuestStatus={selectedQuestStatus}
        setSelectedQuestStatus={setSelectedQuestStatus}
        selectedSort={selectedSort}
        setSelectedSort={setSelectedSort}
        selectedDurationStatus={selectedDurationStatus}
        setSelectedDurationStatus={setSelectedDurationStatus}
        questGenreTags={questGenreTags}
        selectedQuestGenreTags={selectedQuestGenreTags}
        setSelectedQuestGenreTags={setSelectedQuestGenreTags}
      />
      <div css={questListContainerStyle}>
        <Banner categoryId={props.category.id} />
        {collaboratedQuests.length > 0 && (
          <CollaborationQuestList
            collaboratedQuests={collaboratedQuests}
            selectedQuestStatus={selectedQuestStatus}
            selectedSort={selectedSort}
            selectedDurationStatus={selectedDurationStatus}
            selectedQuestGenreTags={selectedQuestGenreTags}
          />
        )}

        <div css={questListBodyContainerStyle}>
          <QuestListBody
            quests={props.category.quests}
            selectedQuestStatus={selectedQuestStatus}
            selectedSort={selectedSort}
            selectedDurationStatus={selectedDurationStatus}
            selectedQuestGenreTags={selectedQuestGenreTags}
          />
        </div>
      </div>
    </>
  );
};

const questListContainerStyle = css`
  ${mediaQueryIsDesktop(css`
    padding: 2rem;
  `)};
`;

const questListBodyContainerStyle = css`
  ${mediaQueryIsDesktop(css`
    margin-top: 2rem;
    margin-inline: 2rem;
  `)}
`;

export default QuestTab;
